import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, ITEM, TIME } from '@/plugins/sdk/fields'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Level from '../../Tracking/Level'

export default class extends Resource {
  static name = 'seed'

  static get fields () {
    return {
      id: new UUID(),
      event: new STRING(),
      description: new STRING(),
      created_at: new TIME(),
      updated_at: new TIME(),
      deleted_at: new TIME(),
      carrier: new ITEM(Carrier),
      level: new ITEM(Level)
    }
  }
}
